import {
  SET_TEACHERS
} from './mutationTypes'

export const mutations = {
  [SET_TEACHERS]: (state, payload) => state.teachers = payload
}
